"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Utilities_1 = require("../../Utilities");
var TeachingBubble_base_1 = require("./TeachingBubble.base");
var TeachingBubble_styles_1 = require("./TeachingBubble.styles");
exports.TeachingBubble = Utilities_1.styled(TeachingBubble_base_1.TeachingBubbleBase, TeachingBubble_styles_1.getStyles, undefined, { scope: 'TeachingBubble' });
//# sourceMappingURL=TeachingBubble.js.map


//////////////////
// WEBPACK FOOTER
// ./~/office-ui-fabric-react/lib-commonjs/components/TeachingBubble/TeachingBubble.js
// module id = 1214
// module chunks = 0